/**
 * Analytics tracking for SearchJobRedirect component
 */

/**
 * Push search analytics to data layer
 */
export const pushSearchAnalytics = (searchText: string): void => {
  if (window.dataLayer && searchText) {
    window.dataLayer.push({
      event: 'interaction',
      eventSource: 'aem',
      action: 'search',
      componentName: 'searchJobRedirect',
      interactionType: 'search',
      data: {},
      title: 'Search for a role',
      property: 'searchJobs',
      href: '',
      selection: [searchText],
    })
  }
}

/**
 * Push location selection analytics to data layer
 */
export const pushLocationAnalytics = (selectedLocations: string[]): void => {
  if (window.dataLayer && selectedLocations.length > 0) {
    window.dataLayer.push({
      event: 'interaction',
      eventSource: 'aem',
      action: 'filter',
      componentName: 'searchJobRedirect',
      interactionType: 'select',
      data: {},
      title: 'Location',
      property: 'location',
      href: '',
      selection: selectedLocations,
    })
  }
}

/**
 * Push combined search and redirect analytics
 */
export const pushRedirectAnalytics = (searchText: string, selectedLocations: string[], redirectUrl: string): void => {
  if (window.dataLayer) {
    const selection: string[] = []
    
    if (searchText) {
      selection.push(`search:${searchText}`)
    }
    
    if (selectedLocations.length > 0) {
      selection.push(`locations:${selectedLocations.join(',')}`)
    }

    window.dataLayer.push({
      event: 'interaction',
      eventSource: 'aem',
      action: 'redirect',
      componentName: 'searchJobRedirect',
      interactionType: 'click',
      data: {
        searchText,
        locations: selectedLocations,
      },
      title: 'Find a Job',
      property: 'jobSearch',
      href: redirectUrl,
      selection,
    })
  }
}

/**
 * Get data-dm attribute for analytics tracking
 */
export const getDataDmAttribute = (elementType: 'search' | 'location' | 'button'): string => {
  return `searchJobRedirect.${elementType}`
}
